import AdvancedDMSselectionModal from "./AdvancedDMSselectionModal";
import {InputAdornment, TextField} from "@mui/material";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {useEffect, useState} from "react";
import {IconButton} from "@mui/material/";

interface itemInterface {
    code: string,
    name: string,
    area?: string,
    country: string,
    region?: string,
    province: string,
    city: string
}

interface AdvancedDMSselectorProps {
    disabled?: boolean,
    required?: boolean,
    error?: any,
    items: itemInterface[],
    label: string,
    placeholder?: string,
    setValue?: Function,
    fieldName?: string,
    value?: any[],
    tenantId?: string
}

const AdvancedDmsSelector = ({
                                 disabled,
                                 required,
                                 error,
                                 items,
                                 label,
                                 placeholder,
                                 value,
                                 setValue,
                                 fieldName,
                                 tenantId
                             }: AdvancedDMSselectorProps) => {

    const [openDMSselector, setOpenDMSselector] = useState(false);
    const [currentItems, setCurrentItems] = useState<itemInterface[]>(items);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);

    useEffect(() => {
        setCurrentItems(items);
    }, [items])

    useEffect(() => {
        if (value) {
            setSelectedItems(value);
        }
    }, [value])

    const updateSelectedItems = (data: any) => {
        setSelectedItems(data);
        if (setValue) {
            setValue(fieldName, data);
        }
    }

    return (
        <>
            <TextField
                id="outlined-read-only-input"
                fullWidth
                label={label}
                placeholder={placeholder}
                disabled={disabled}
                required={required}
                value={selectedItems.length > 0 && items.length > 0 ? selectedItems.map((l: any) => items.find((ll: any) => ll.sapId === l)?.name).join(', ') : ""}
                error={error !== undefined}
                helperText={error?.message}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton disabled={disabled} onClick={() => setOpenDMSselector(true)}
                                        aria-label="open selector">
                                <AddRoundedIcon/>
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            {openDMSselector &&
                <AdvancedDMSselectionModal open={openDMSselector} handleClose={() => setOpenDMSselector(false)}
                                           selectedItems={selectedItems} setSelectedItems={updateSelectedItems}
                                           items={currentItems}/>
            }
        </>
    )
}

export default AdvancedDmsSelector;